// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1LRg3","Label":"Checkbox_Label__2vo8C","InputElement":"Checkbox_InputElement__tPpgR","Invalid":"Checkbox_Invalid__3zPBI"};